import type { DailyFilters, DailyUsageDTO } from '../../usage.types';
import type IDailyUsageRepository from '../IDailyUsageRepository';
import API from '@repositories/Axios';
import type { Page } from '@type/Page';
import qs from 'qs';
import { injectable } from 'inversify';
import 'reflect-metadata';

@injectable()
export class DailyUsageRepository implements IDailyUsageRepository {
  async create(/* data: unknown */): Promise<DailyUsageDTO> {
    throw new Error('Method not implemented.');
  }
  async getList(queries?: DailyFilters): Promise<Page<DailyUsageDTO>> {
    const queryString = qs.stringify(queries);

    const result = await API.get<Page<DailyUsageDTO>>(`/api/v1/daily-usages?${queryString}`);
    return result.data;
  }
}
